export class MockCircleService {
  getCircles = jasmine.createSpy('getCircles');
  getCircle = jasmine.createSpy('getCircle');
  updateCircle = jasmine.createSpy('updateCircle');
  createCircle = jasmine.createSpy('createCircle');
  deleteCircle = jasmine.createSpy('deleteCircle');
  addMemberToCircle = jasmine.createSpy('addMemberToCircle');
  deleteMemberFromCircle = jasmine.createSpy('deleteMemberFromCircle');
}
